import * as React from 'react';

class Header extends React.Component {
  public render() {
    return (
      <header className="app-header">

        <h1 className="app-title">
          <a href="https://www.stellenanbieter.de" target="_blank">
            <img
              src="https://www.stellenanbieter.de/fileadmin/layout/logo-stellenanbieter-white.png"
              alt="Logo Stellenanbieter.de Stellenangebote"
            />
          </a>
        </h1>
        <div className="header-menu">
          <a href="https://www.stellenanbieter.de" target="_blank">Zurück zur Webseite</a>
          <a href="https://www.stellenanbieter.de/login/" target="_blank">Stellenangebot schalten</a>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.tsx